import { render } from "./TextQuestion.vue?vue&type=template&id=3b936e12&scoped=true"
import script from "./TextQuestion.vue?vue&type=script&lang=js"
export * from "./TextQuestion.vue?vue&type=script&lang=js"

import "./TextQuestion.vue?vue&type=style&index=0&id=3b936e12&scoped=true&lang=css"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b936e12"]])

export default __exports__